import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoAcao from "model/documentos/acesso/DocumentoAcao";
import DocumentoAcesso from "model/documentos/acesso/DocumentoAcesso";
import DocumentoAcessoGrupo from "model/documentos/acesso/DocumentoAcessoGrupo";
import DocumentoAcessoUsuario from "model/documentos/acesso/DocumentoAcessoUsuario";
import DocumentoPastaAcao from "model/documentos/acesso/DocumentoPastaAcao";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { TabPanel, TabView } from "primereact/tabview";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoAcessoService from "service/documentos/DocumentoAcessoService";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";

type Props = {
    visible: boolean;
    onHide: () => void;
    idDocumento: number;
    onConfirm: () => void;
}

const documentoAcessoService = new DocumentoAcessoService();
export default function ModalDocumentoAcesso(props: Props) {
    const [documentoAcesso, setDocumentoAcesso] = useState<DocumentoAcesso>(new DocumentoAcesso());
    const [acoes, setAcoes] = useState<DocumentoAcao[]>([]);

    const [visibleGrupo, setVisibleGrupo] = useState<boolean>(false);
    const [grupoSelecionado, setGrupoSelecionado] = useState<GrupoUsuarios | null>(null);

    const [visibleUsuario, setVisibleUsuario] = useState<boolean>(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState<Usuario | null>(null);

    const [grupos, setGrupos] = useState<GrupoUsuarios[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();

    function handleConfirm() {
        startLoading();
        documentoAcessoService.salvar(documentoAcesso).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao mover", error?.data?.message || "Erro ao mover pasta");
            console.error("Erro ao mover pasta:", error);
        });

    }

    useEffect(() => {
        documentoAcessoService.buscarAcessos(props.idDocumento).then((json) => {
            setDocumentoAcesso(json);
        }).catch((error) => {
            console.error("Erro ao buscar pastas:", error);
        });
        documentoAcessoService.buscarAcoes().then((json) => {
            setAcoes(json);
        }).catch((error) => {
            console.error("Erro ao buscar ações:", error);
        });
        documentoAcessoService.usuarios().then((json) => {
            setUsuarios(json);
        }).catch((error) => {
            console.error("Erro ao buscar usuários:", error);
        });
        documentoAcessoService.grupos().then((json) => {
            setGrupos(json);
        }).catch((error) => {
            console.error("Erro ao buscar grupos:", error);
        });
    }, [])

    return (
        <Dialog
            header="Acesso ao documento"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '85%' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Gravar" icon="pi pi-check" onClick={handleConfirm} />
            </>}
        >
            <Dialog
                header={visibleGrupo ? "Adicionar Grupo" : "Adicionar Usuário"}
                footer={<Button label="Confirmar" onClick={() => {
                    if (visibleGrupo) {
                        if (documentoAcesso.grupos.findIndex((grupo) => grupo.grupo.id === grupoSelecionado?.id) > -1) {
                            msgAlerta("Grupo já adicionado", "O grupo selecionado já foi adicionado.");
                            return;
                        }
                        setDocumentoAcesso({ ...documentoAcesso, grupos: [...documentoAcesso.grupos, new DocumentoAcessoGrupo(grupoSelecionado!, [])] });
                        setGrupoSelecionado(null);
                        setVisibleGrupo(false);
                    } else {
                        if (documentoAcesso.usuarios.findIndex((usuario) => usuario.usuario.id === usuarioSelecionado?.id) > -1) {
                            msgAlerta("Usuário já adicionado", "O usuário selecionado já foi adicionado.");
                            return;
                        }
                        setDocumentoAcesso({ ...documentoAcesso, usuarios: [...documentoAcesso.usuarios, new DocumentoAcessoUsuario(usuarioSelecionado!, [])] });
                        setUsuarioSelecionado(null);
                        setVisibleUsuario(false);
                    }
                }} />}
                visible={visibleGrupo || visibleUsuario}
                onHide={() => {
                    setVisibleGrupo(false);
                    setVisibleUsuario(false);
                    setGrupoSelecionado(null);
                    setUsuarioSelecionado(null);
                }}
            >
                {visibleGrupo ? <Dropdown
                    value={visibleGrupo ? grupoSelecionado : usuarioSelecionado}
                    options={visibleGrupo ? grupos : usuarios}
                    optionLabel={"nome"}
                    placeholder={visibleGrupo ? "Selecione um grupo" : "Selecione um usuário"}
                    onChange={(e) => {
                        if (visibleGrupo) {
                            setGrupoSelecionado(e.value as GrupoUsuarios);
                        } else {
                            setUsuarioSelecionado(e.value as Usuario);
                        }
                    }}
                /> : <AutoComplete
                    dropdown
                    value={usuarioSelecionado}
                    placeholder="Selecione um Usuário"
                    field="nome"
                    itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                    suggestions={usuariosFiltrados}
                    completeMethod={(e) => {
                        let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                        setUsuariosFiltrados(filtered);
                    }}
                    onChange={(e) => {
                        setUsuarioSelecionado(e.value);
                    }}
                />}
            </Dialog>
            <TabView >
                <TabPanel header="Grupos">
                    <DataTable value={documentoAcesso.grupos} header={<>
                        <Button
                            label="Adicionar grupo"
                            icon="pi pi-plus"
                            onClick={() => {
                                setVisibleGrupo(true);
                            }}
                        />
                    </>} scrollable scrollHeight="flex" emptyMessage="Nenhum grupo cadastrado">
                        <Column field="grupo.nome" header="Grupo" style={{ width: "30%" }} frozen />
                        <Column header="Marcar todas" body={rowData => {
                            return (
                                <Checkbox
                                    checked={rowData.acoes.length === acoes.length}
                                    onChange={(e) => {
                                        if (e.checked) {
                                            rowData.acoes = [...acoes];
                                        } else {
                                            rowData.acoes = [];
                                        }
                                        setDocumentoAcesso({ ...documentoAcesso });
                                    }}
                                />
                            );
                        }} />
                        {acoes.map((acao) => {
                            return (
                                <Column key={acao.id} header={acao.nome} bodyStyle={{ textAlign: "center" }} body={(rowData: DocumentoAcessoGrupo) => {
                                    return (
                                        <Checkbox

                                            checked={rowData.acoes.findIndex((acaoGrupo) => acaoGrupo.id == acao.id) > -1}
                                            onChange={(e) => {
                                                if (e.checked) {
                                                    rowData.acoes.push(acao);
                                                } else {
                                                    rowData.acoes = rowData.acoes.filter((acaoGrupo) => acaoGrupo.id !== acao.id);
                                                }
                                                setDocumentoAcesso({ ...documentoAcesso })
                                            }}
                                        />
                                    );
                                }} />
                            );
                        })}
                        <Column header="" body={(rowData: DocumentoAcessoGrupo) => <Button
                            icon="pi pi-trash"
                            className="p-button-danger"
                            onClick={() => {
                                documentoAcesso.grupos = documentoAcesso.grupos.filter((grupo) => grupo.grupo.id !== rowData.grupo.id);
                                setDocumentoAcesso({ ...documentoAcesso });
                            }}
                        />} >
                        </Column>
                    </DataTable>
                </TabPanel>
                <TabPanel header="Usuários">
                    <DataTable value={documentoAcesso.usuarios} header={<>
                        <Button
                            label="Adicionar usuário"
                            icon="pi pi-plus"
                            onClick={() => {
                                setVisibleUsuario(true);
                            }}
                        />
                    </>} scrollable scrollHeight="flex" emptyMessage="Nenhum usuário cadastrado">
                        <Column field="usuario.nome" header="Usuário" style={{ width: "30%" }} frozen />
                        <Column header="Marcar todas" body={rowData => {
                            return (
                                <Checkbox
                                    checked={rowData.acoes.length === acoes.length}
                                    onChange={(e) => {
                                        if (e.checked) {
                                            rowData.acoes = [...acoes];
                                        } else {
                                            rowData.acoes = [];
                                        }
                                        setDocumentoAcesso({ ...documentoAcesso });
                                    }}
                                />
                            );
                        }} />
                        {acoes.map((acao) => {
                            return (
                                <Column key={acao.id} header={acao.nome} style={{ textAlign: "center" }} body={(rowData: DocumentoAcessoGrupo) => {
                                    return (
                                        <Checkbox
                                            checked={rowData.acoes.findIndex((acaoUsuario) => acaoUsuario.id == acao.id) > -1}
                                            onChange={(e) => {
                                                if (e.checked) {
                                                    rowData.acoes.push(acao);
                                                } else {
                                                    rowData.acoes = rowData.acoes.filter((acaoUsuario) => acaoUsuario.id !== acao.id);
                                                }
                                                setDocumentoAcesso({ ...documentoAcesso })
                                            }}
                                        />
                                    );
                                }} />
                            );
                        })}
                        <Column header="" body={(rowData: DocumentoAcessoUsuario) => <Button
                            icon="pi pi-trash"
                            className="p-button-danger"
                            onClick={() => {
                                documentoAcesso.usuarios = documentoAcesso.usuarios.filter((usuario) => usuario.usuario.id !== rowData.usuario.id);
                                setDocumentoAcesso({ ...documentoAcesso });
                            }}
                        />} ></Column>
                    </DataTable>
                </TabPanel>
            </TabView>

        </Dialog >
    );
}